import { useContext } from "react";
import { SidebarToggleContext } from "./context";

export const useSidebarToggle = () => useContext(SidebarToggleContext);
